<template>
  <div>
    <h1>Manager Dashboard</h1>
  </div>
</template>

<script>
export default {
  name: 'ManagerDashboard'
}
</script>